import { GuaranteeStatus } from './guarantee-constants';
import { GuaranteeRequestAttachment } from './guarantee-request-attachment';
import { Part } from './part';

export class Guarantee {
	id: string | undefined;
	guaranteeId: string | undefined;
	certificateId: string | undefined;
	applicationType = '';
	requesterId = 0;
	recordType = 'Magnelis';
	requesterName = '';
	status: GuaranteeStatus = GuaranteeStatus.DRAFT;
	dataOnTheProjectSize = '';
	magnelisTonnage = '';
	mspCompanyName = '';
	epcCompanyName = '';
	createdDate: string | undefined;
	lastModifiedDate: string | undefined;
	requestDate: string | undefined;
	installationType = '';
	newSolarplantCompleteConstruction = false;
	extensionExistingSolarplant = false;
	retrofitting = false;
	soldTo = '';
	name = '';
	address = '';
	latitude = '';
	longitude = '';
	ruralAreaDistantFromCoast = false;
	proximityBuildingAnimals = false;
	distanceToSea = '';
	urbanOrIndustrialArea = false;
	mainlyComprisingRefinerie = false;
	hazardousIndustryDistance = '';
	typeOfIndustry = '';
	typeOfEmissions = '';
	gasCarriedWinds!: string;
	inDesert = false;
	desertComment = '';
	coastalMarineEnvironment = false;
	lessThan300mfromCoast = false;
	withoutWettingSeaWater = false;
	partialWettingSeaWater = false;
	between300m2kmfromCoast = false;
	between2km10kmfromCoast = false;
	specificEnvironment = false;
	distancetoLakeRiver = '';
	upperStructureGuarantee = false;
	magnelisZM310 = false;
	magnelisZM430 = false;
	magnelisZM620 = false;
	guaranteeDurationRequested = '';
	polesGuarantee = false;
	polesMagnelisZM430 = false;
	polesMagnelisZM620 = false;
	polesMagnelisZM800 = '';
	poleGuaranteeDurationRequested = '';
	soilAnalysis = false;

	floatingSolarInstallation = '';
	guaranteeForFloatingSolarMagnelis = 'No';
	floatingSolarMagnelisZM430 = '';
	floatingSolarMagnelisZM620 = '';
	floatingSolarMagnelisZM800 = '';
	guaranteeDurationRequestedForFoating = '';
	floatingSolarInstallationAnalysis = 'No';
	entireMagnelisStructure = false;
	stainlessSteelParts = false;
	aluminiumParts = false;
	stainlessSteel = false;
	zincCoated = false;
	foundationsConcrete = false;
	otherCoatingsSteel = false;
	aluminium = false;
	magnelisContactPartsCoating = '';
	magnelisContactPartsOtherMaterial = '';
	customerAdditionalInformation = '';
	newBuildingCompleteConstruction!: boolean;
	extensionExistingBuilding = false;
	retrofittingRepairExistingBuilding = false;
	roofing = false;
	wallFacade = false;
	compositeFloor = false;
	perforatedroofSheet = false;
	perSheetRich = '';
	coldFormedStrut = false;
	rainWaterSystemsGutters = false;
	residentialUse = false;
	agricultural = false;
	industrial = false;
	otherADB = false;
	otherADBSpecify = '';
	acitivityInsideBuilding = '';
	presenceofChemical = '';
	natureContent = '';
	presenceofFermentation = '';
	natureContent2 = '';
	cattle = false;
	pigs = false;
	polutry = false;
	otherAnimals = false;
	gasvaporNatureContent = '';
	animalsInsideBuilding = '';
	densityofAnimals = '';
	animalsinShed = '';
	heatingType = '';
	qiaExtractor = false;
	qiaChimney = false;
	qiaNaturalventilation = false;
	qiaForcedventilation = false;
	otherEquipment = false;
	specifyOtherEquipment = '';
	qiacondriskbuilding = '';
	humiditySpec = '';
	manureManagementGrantings = false;
	manureManagementWOGrantings = false;
	animalDistance = '';
	suggestedCoatingMass = false;
	parts: Part[] = [];
	attachments: GuaranteeRequestAttachment[] = [];
	toaSilo = false;
	siloBase = false;
	siloProductsStored = '';
	linerInSilo = false;
	siloRoof = false;
	siloCylinder = false;
	siloInContactSoilConcrete = false;
	toaRoadResSystem = false;
	rrsHorizontal = false;
	rrsMiscellaneous = false;
	rrsMagnelisWelded = false;
	rrsPoles = false;
	toaAcousticBarrier = false;
	acoRoadTraffic = false;
	acoRailroad = false;
	acoConcreteBase = false;
	toaPerforatedSheet = false;
	peforatedSheet = false;
	perPerRich = '';
	perApp = '';
	isTOAOtherApps = false;
	toaOtherApplication = '';
	isOtherCoatingMass = false;
	otherCoatingMass = '';
	gasVapour = '';
	buildingHeated = '';
	reason = '';
	natureMaterial = '';
	conditionMaterial = '';
	ageMaterial = '';
	industrialBuilding = false;
	agriculturalBuilding = false;
	storageFodder = false;
	storageFertilizer = false;
	breedingAnimals = false;
	concreteGratingDuckboard = false;
	noDuckboard = false;
	naturalVentilationWall = false;
	naturalVentilationRoof = false;
	forcedVentilation = false;
	otherVentilation = false;
	otherVentilationSpecify = '';
	airRenewal = '';
	ammonia = '';
	hydrogenSulphide = '';
	humidity = '';
	buildingEnvAltitude = false;
	buildingEnvBLMoreThan20KMFromCoast = false;
	buildingEnvBLSpecifyDistance = false;
	buildingEnvBLPleaseSpecify = '';
	typeOfGuaGrOutdoor = false;
	typeofGuaGrIndoor = false;
	outdoorGuaranteeDurationExpected = '';
	indoorGuaranteeDurationExpected = '';
	typeOfGUAOpenBuildingYes = false;
	typeOfGUAOpenBuildingYesSpecify = '';
	ocRoofing = false;
	roofingDeckingRoof = false;
	roofingDRSubstrateThickness = '';
	roofingDRDesiredCoating = '';
	roofingDRDesiredBackCoating = '';
	roofingDRMetallicCoatingWeight = '';
	roofingDRColor = '';
	roofingDRSurface = '';
	roofingDRRoofslope = '';
	roofingSingleSkinRoof = false;
	roofingSSRSubstrateThickness = '';
	roofingSSRDesiredCoating = '';
	roofingSSRDesiredBackCoating = '';
	roofingSSRMetallicCoatingWeight = '';
	roofingSSRColor = '';
	roofingSSRSurface = '';
	roofingSSRRoofslope = '';
	roofingDoubleSkinRoof = false;
	roofingDsresSubstrateThickness = '';
	roofingDsresDesiredCoating = '';
	roofingDsresDesiredBackCoating = '';
	roofingDsresMetallicCoatingWeight = '';
	roofingDsrEsColor = '';
	roofingDsrisSubstrateThickness = '';
	roofingDsrisDesiredCoating = '';
	roofingDsrisDesiredBackCoating = '';
	roofingDsrisMetallicCoatingWeight = '';
	roofingDsrIsColor = '';
	roofingDSRSurface = '';
	roofingDSRRoofslope = '';
	roofingSandwichPanelsBuiltUpSys = false;
	roofingSPESSubstrateThickness = '';
	roofingSPESDesiredCoating = '';
	roofingSPESDesiredBackCoating = '';
	roofingSPESMetallicCoatingWeight = '';
	roofingSPESColor = '';
	roofingSPISSubstrateThickness = '';
	roofingSPISDesiredCoating = '';
	roofingSPISDesiredBackCoating = '';
	roofingSPISMetallicCoatingWeight = '';
	roofingSPISColor = '';
	roofingSPSurface = '';
	roofingSPRoofslope = '';
	roofingSPInsulationPU = false;
	roofingSPInsulationPIR = false;
	roofingSPInsulationMineralWool = false;
	roofingOverlapping = '';
	roofingPerforationYes = '';
	roofingPerforationYesSpecify = '';
	roofingPVSolarRoof = '';
	roofingAntiCondensationFelt = '';
	clad = false;
	cladSingleSkin = false;
	cladSSSubstrateThickness = '';
	cladSSDesiredCoating = '';
	cladSSDesiredBackCoating = '';
	cladSSMetallicCoatingWeight = '';
	cladSSColor = '';
	cladSSSurface = '';
	cladDoubleSkin = false;
	cladDSESSubstrateThickness = '';
	cladDSESDesiredCoating = '';
	cladDSESDesiredBackCoating = '';
	cladDSESMetallicCoatingWeight = '';
	cladDSESColor = '';
	cladDSESSurface = '';
	cladDSISSubstrateThickness = '';
	cladDSISDesiredCoating = '';
	cladDSISDesiredBackCoating = '';
	cladDSISMetallicCoatingWeight = '';
	cladDSISColor = '';
	cladDSISSurface = '';
	cladSandwichPanelsBuiltUpSys = false;
	cladSPESSubstrateThickness = '';
	cladSPESDesiredCoating = '';
	cladSPESDesiredBackCoating = '';
	cladSPESMetallicCoatingWeight = '';
	cladSPESColor = '';
	cladSPISSubstrateThickness = '';
	cladSPISDesiredCoating = '';
	cladSPISDesiredBackCoating = '';
	cladSPISMetallicCoatingWeight = '';
	cladSPISColor = '';
	cladSPSurface = '';
	cladSPInsulationPU = false;
	cladSPInsulationPIR = false;
	cladSPInsulationMineralWool = false;
	cladOverlapping = '';
	cladPerforationYes = '';
	cladPerforationYesSpecify = '';
	cladDirectionOfInstallation = false;
	cladVertical = false;
	othersAntiCondensationFelt = false;
	othersSpecifyAntiCondensationFelt = '';
	omuRoofCladmadeWithProduct = false;
	omuUseofMaterialCementBreezeblocks = false;
	omuInRoofing = '';
	omuInCladding = '';
	buildingHumidityRate = '';
	crmAttachments: GuaranteeRequestAttachment[] = [];
	certificates: GuaranteeRequestAttachment[] = [];
	certificateDocument?: GuaranteeRequestAttachment;

	get contactParts() {
		return this.magnelisContactPartsCoating !== '';
	}

	get contactOtherParts() {
		return this.magnelisContactPartsOtherMaterial !== '';
	}

	get activityBuilding() {
		return this.acitivityInsideBuilding !== '';
	}

	get ambienceBuilding() {
		return this.agriculturalBuilding && (this.equipment || this.humidity !== '');
	}

	get activityAgriculturalBuilding() {
		return this.agriculturalBuilding && (this.storageFodder || this.storageFertilizer || this.breedingAnimals);
	}

	get animalsBuilding() {
		return this.cattle || this.pigs || this.polutry || this.otherAnimals;
	}

	get manureManagementOrganic() {
		return this.concreteGratingDuckboard || this.noDuckboard;
	}

	get manureManagementBuilding() {
		return this.manureManagementGrantings || this.manureManagementWOGrantings;
	}

	get discharge() {
		return this.qiaExtractor || this.qiaChimney || this.qiaNaturalventilation
			|| this.qiaForcedventilation || this.otherEquipment;
	}

	get equipment() {
		return this.naturalVentilationWall || this.naturalVentilationRoof || this.forcedVentilation
			|| this.otherVentilation || this.airRenewal !== '' || this.ammonia !== '' || this.hydrogenSulphide !== '';
	}
}
